import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { WA_GREEN } from '../whatsappPreview';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { EmbeddedLinkCore } from '../../../../flow-core/components/EmbeddedLinkCore';

export const EmbeddedLinkComponent = new FlowComponent({
  ...EmbeddedLinkCore,
  renderPreview(properties) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, my: 2, color: WA_GREEN }}>
        <OpenInNewIcon sx={{ fontSize: 16 }} />
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'inherit' }}>{properties.text || 'Link Text'}</Typography>
      </Box>
    );
  },
  renderPropertyEditor(properties, onChange) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          fullWidth
          label="Link Text"
          value={properties.text || ''}
          onChange={(e) => onChange('text', e.target.value)}
          required
          size="small"
        />

        <TextField
          fullWidth
          label="URL"
          value={properties.url || ''}
          onChange={(e) => onChange('url', e.target.value)}
          required
          size="small"
          helperText="Must be a valid URL (e.g., https://example.com)"
        />
      </Box>
    );
  },
});
